import React from 'react';
import urlItem from './routeFactory';
const Login = urlItem('/Login');
const Home = urlItem('/Home');
const ArcadeLanding = urlItem('/ArcadeLanding');
const ArcadeLandingGames = urlItem('/ArcadeLanding/Games');
const ArcadeLandingAboutUs = urlItem('/ArcadeLanding/AboutUs');
const BlockBlastAppHome = urlItem('/BlockBlastAppHome');
const AboutUs = urlItem('/AboutUs');
const Games = urlItem('/Games');
const Blog = urlItem('/Blog');
const Media = urlItem('/Media');
const Social = urlItem('/Social');
const Contact = urlItem('/Contact');
const Introduce = urlItem('/Introduce');
const MessageInfo = urlItem('/MessageInfo');
const MorePage = urlItem('/MorePage');
const SocialHotSpot = urlItem('/SocialHotSpot');
const SocialSelected = urlItem('/SocialSelected');

const Test = urlItem('/Test');
const Advertisement = urlItem('/advertisement');
import { HomeOutlined, BarsOutlined } from '@ant-design/icons';

import menuAboutUs from 'assets/imgs/menu_about-us.png';
import menuGames from 'assets/imgs/menu_games.png';
import menuSocial from 'assets/imgs/menu_social.png';
import menuContact from 'assets/imgs/menu_contact.png';
import menuBlog from 'assets/imgs/menu_blog.png';
import menuMedia from 'assets/imgs/menu_media.png';
import menuAdvertisement from 'assets/adx/diamond/ADVERTISING.png';
export interface RouterProps {
  path: string;
  menuName: string;
  component: any;
  menuIcon?: any;
  color?: string;
}

// 需要侧边栏的路由
export const routeUrl: RouterProps[] = [];

// 需要侧边栏的路由（需要缓存）
export const catchRouteUrl: RouterProps[] = [];

// 不需要侧边栏的路由
export const routeUrlNoSider: RouterProps[] = [
  {
    path: `/login`,
    menuName: '',
    component: Login,
  },
  {
    path: `/home`,
    menuName: 'nav.home',
    component: Home,
    menuIcon: '',
  },
  {
    path: `/arcade-landing`,
    menuName: '',
    component: ArcadeLanding,
  },
  {
    path: `/arcade-landing/games`,
    menuName: '',
    component: ArcadeLandingGames,
  },
  {
    path: `/arcade-landing/about-us`,
    menuName: '',
    component: ArcadeLandingAboutUs,
  },
  {
    path: `/blockblast/gp/apphome`,
    menuName: '',
    component: BlockBlastAppHome,
  },
  {
    path: `/about-us`,
    menuName: 'nav.about',
    component: AboutUs,
    menuIcon: menuAboutUs,
    color: 'orange',
  },
  {
    path: `/games`,
    menuName: 'nav.games',
    component: Games,
    menuIcon: menuGames,
    color: 'cyan',
  },
  {
    path: `/advertisement`,
    menuName: 'ADVERTISEMENT',
    component: Advertisement,
    menuIcon: menuAdvertisement,
    color: 'blue',
  },
  {
    path: `/blogs`,
    menuName: 'nav.blogs',
    component: Blog,
    menuIcon: menuBlog,
    color: 'green',
  },
  {
    path: `/blogs/more`,
    menuName: 'nav.morePage',
    component: MorePage,
  },
  {
    path: `/media`,
    menuName: 'nav.media',
    component: Media,
    menuIcon: menuMedia,
    color: 'yellow',
  },
  {
    path: `/media/more`,
    menuName: 'nav.morePage',
    component: MorePage,
  },
  {
    path: `/social`,
    menuName: 'nav.social',
    component: Social,
    color: 'red',
  },
  {
    path: `/social/selected`,
    menuName: 'nav.social',
    component: SocialSelected,
    menuIcon: menuSocial,
    color: 'red',
  },
  {
    path: `/social/hotspot`,
    menuName: 'nav.social',
    component: SocialHotSpot,
    color: '#ff514f',
  },
  {
    path: `/contact`,
    menuName: 'nav.contact',
    component: Contact,
    menuIcon: menuContact,
    color: 'purple',
  },

  {
    path: `/:type/info/:id`,
    menuName: 'nav.info',
    component: MessageInfo,
  },

  {
    path: '/test',
    menuName: 'nav.test',
    component: Test,
  },
  {
    path: '/advertisement',
    menuName: 'WORLD MAP',
    component: Advertisement,
  },
];
